import axios, {AxiosRequestConfig, AxiosResponse} from 'axios'
import httpClient from './index'
import url from './url'
import {AuthenticatePayload} from '../props_reusable/authentication'

class AuthenticationService {
  private static get client() {
    return httpClient.instance
  }

  static getAuthenticationType<T>(
    orderGUID: string,
    config?: AxiosRequestConfig,
  ): Promise<T> {
    return this.client
      .get(url.getAuthType(orderGUID), config)
      .then((response: AxiosResponse<T>) => response.data)
      .catch(error => {
        if (axios.isAxiosError(error) && error.response)
          throw new Error(`${error.response.status}`)
        else throw new Error('500')
      })
  }

  static authenticate<T>(
    orderGUID: string,
    payload: Partial<AuthenticatePayload> = {},
  ): Promise<T> {
    return this.client
      .post(url.authenticate(orderGUID), payload)
      .then((response: AxiosResponse<T>) => response.data)
      .catch(error => {
        if (axios.isAxiosError(error) && error.response)
          throw new Error(`${error.response.status}`)
        else throw new Error('500')
      })
  }
}

export default AuthenticationService
